import React from 'react'
import ReporteEnTransitoPlayaCalado from '../../components/ReporteEnTransitoPlayaCalado'
import ReporteCamiones from '../ReporteCamiones'

function ReporteCamionesAPlayaCalado (props) {
  const { cpaEntrePlayaCalado, cortesPedidos } = props

  return (
    <ReporteCamiones
      buttonName='Entre playa y calado'
      contenido={<ReporteEnTransitoPlayaCalado
        cpaEntrePlayaCalado={cpaEntrePlayaCalado}
        cortesPedidos={cortesPedidos}
      />
      }
    />
  )
}

export default ReporteCamionesAPlayaCalado
